import { useMemo } from 'react';

function parseCookies() {
  return document.cookie.split('; ').reduce((cookies, cookie) => {
    const [key, value] = cookie.split('=');
    cookies[key] = value;
    return cookies;
  }, {});
}

export default function useCookie() {
  const cookies = useMemo(() => {
    return parseCookies();
  }, []);

  function getCookie(keyName) {
    return cookies[keyName];
  }

  function hasCookie(keyName) {
    return cookies.hasOwnProperty(keyName);
  }

  return {
    getCookie,
    hasCookie,
  };
}
